//
// helpers/remove-node.js - remove a dom node
//

export default function remove_node(n) {
  n.parentNode.removeChild(n);
}
